
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecde7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecde7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = new Map();
function $ef7689007096c8a0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ef7689007096c8a0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $4569aa76eba2ec90$exports = {};

(parcelRequire("kyEFX")).register(new URL("", import.meta.url).toString(), JSON.parse('["6TNLe","index.ff7952bd.js","4w5pq","digital.f12f83cd.jpg","ajnll","grow.f0f64dd7.jpg","85Zfm","card.f075fa3f.jpg"]'));

var $f0600783150be9f9$exports = {};
$f0600783150be9f9$exports = new URL("digital.f12f83cd.jpg", import.meta.url).toString();


var $2a2d7f14d7828bc1$exports = {};
$2a2d7f14d7828bc1$exports = new URL("grow.f0f64dd7.jpg", import.meta.url).toString();


var $5e44f7f1cd015b56$exports = {};
$5e44f7f1cd015b56$exports = new URL("card.f075fa3f.jpg", import.meta.url).toString();


const $1ee2b6306238ec66$var$modal = document.querySelector(".modal");
const $1ee2b6306238ec66$var$overlay = document.querySelector(".overlay");
const $1ee2b6306238ec66$var$btnCloseModal = document.querySelector(".btn--close-modal");
const $1ee2b6306238ec66$var$btnsOpenModal = document.querySelectorAll(".btn--show-modal");
const $1ee2b6306238ec66$var$btnScrollTo = document.querySelector(".btn--scroll-to");
const $1ee2b6306238ec66$var$section1 = document.querySelector("#section--1");
const $1ee2b6306238ec66$var$nav = document.querySelector(".nav");
const $1ee2b6306238ec66$var$tabs = document.querySelectorAll(".operations__tab");
const $1ee2b6306238ec66$var$tabsContainer = document.querySelector(".operations__tab-container");
const $1ee2b6306238ec66$var$tabsContent = document.querySelectorAll(".operations__content");
// Modal window
const $1ee2b6306238ec66$var$openModal = function(e) {
    e.preventDefault();
    $1ee2b6306238ec66$var$modal.classList.remove("hidden");
    $1ee2b6306238ec66$var$overlay.classList.remove("hidden");
};
const $1ee2b6306238ec66$var$closeModal = function() {
    $1ee2b6306238ec66$var$modal.classList.add("hidden");
    $1ee2b6306238ec66$var$overlay.classList.add("hidden");
};
$1ee2b6306238ec66$var$btnsOpenModal.forEach((btn)=>btn.addEventListener("click", $1ee2b6306238ec66$var$openModal));
$1ee2b6306238ec66$var$btnCloseModal.addEventListener("click", $1ee2b6306238ec66$var$closeModal);
$1ee2b6306238ec66$var$overlay.addEventListener("click", $1ee2b6306238ec66$var$closeModal);
document.addEventListener("keydown", function(e) {
    if (e.key === "Escape" && !$1ee2b6306238ec66$var$modal.classList.contains("hidden")) $1ee2b6306238ec66$var$closeModal();
});
// Button scrolling
$1ee2b6306238ec66$var$btnScrollTo.addEventListener("click", function(e) {
    e.preventDefault();
    const options = {
        behavior: "smooth",
        block: "start",
        inline: "nearest"
    };
    const offset = 1 * parseFloat(getComputedStyle(document.documentElement).fontSize);
    $1ee2b6306238ec66$var$section1.style.transform = `translateY(${offset}px)`;
    $1ee2b6306238ec66$var$section1.scrollIntoView(options);
});
// Page navigation
document.querySelector(".nav__links").addEventListener("click", function(e) {
    if (e.target.classList.contains("nav__link")) {
        e.preventDefault();
        const id = e.target.getAttribute("href");
        const targetElement = document.querySelector(id);
        let offset = 1 * parseFloat(getComputedStyle(document.documentElement).fontSize);
        const options = {
            behavior: "smooth",
            block: "start",
            inline: "nearest"
        };
        targetElement.style.transform = `translateY(${offset}px)`;
        targetElement.scrollIntoView(options);
        // Clean up the transformation after scrolling
        targetElement.addEventListener("scrollend", function cleanup() {
            targetElement.style.transform = "none";
            targetElement.removeEventListener("scrollend", cleanup);
        });
    }
});
// Tabbed Component
$1ee2b6306238ec66$var$tabsContainer.addEventListener("click", function(e) {
    const clicked = e.target.closest(".operations__tab");
    if (!clicked) return;
    $1ee2b6306238ec66$var$tabs.forEach((t)=>t.classList.remove("operations__tab--active"));
    $1ee2b6306238ec66$var$tabsContent.forEach((c)=>c.classList.remove("operations__content--active"));
    // Active Tab
    clicked.classList.add("operations__tab--active");
    // Activate content area
    document.querySelector(`.operations__content--${clicked.dataset.tab}`).classList.add("operations__content--active");
});
// Menu Fade Animation
const $1ee2b6306238ec66$var$handleHover = function(e) {
    if (e.target.classList.contains("nav__link")) {
        const link = e.target;
        const siblings = link.closest(".nav").querySelectorAll(".nav__link");
        const logo = link.closest(".nav").querySelector("img");
        siblings.forEach((el)=>{
            if (el !== link) el.style.opacity = this;
        });
        logo.style.opacity = this;
    }
};
$1ee2b6306238ec66$var$nav.addEventListener("mouseover", $1ee2b6306238ec66$var$handleHover.bind(0.5));
$1ee2b6306238ec66$var$nav.addEventListener("mouseout", $1ee2b6306238ec66$var$handleHover.bind(1));
// Sticky Nav using Intersection Observer API
const $1ee2b6306238ec66$var$header = document.querySelector(".header");
const $1ee2b6306238ec66$var$navHeight = $1ee2b6306238ec66$var$nav.getBoundingClientRect().height;
const $1ee2b6306238ec66$var$stickyNav = function(entries) {
    const [entry] = entries;
    if (!entry.isIntersecting) $1ee2b6306238ec66$var$nav.classList.add("sticky");
    else $1ee2b6306238ec66$var$nav.classList.remove("sticky");
};
const $1ee2b6306238ec66$var$headerObserver = new IntersectionObserver($1ee2b6306238ec66$var$stickyNav, {
    root: null,
    threshold: 0,
    rootMargin: `-${$1ee2b6306238ec66$var$navHeight}px`
});
$1ee2b6306238ec66$var$headerObserver.observe($1ee2b6306238ec66$var$header);
// Reveal sections
const $1ee2b6306238ec66$var$allSections = document.querySelectorAll(".section");
const $1ee2b6306238ec66$var$revealSection = function(entries, observer) {
    const [entry] = entries;
    if (!entry.isIntersecting) return;
    entry.target.classList.remove("section--hidden");
    observer.unobserve(entry.target);
};
const $1ee2b6306238ec66$var$sectionObserver = new IntersectionObserver($1ee2b6306238ec66$var$revealSection, {
    root: null,
    threshold: 0.15
});
$1ee2b6306238ec66$var$allSections.forEach(function(section) {
    $1ee2b6306238ec66$var$sectionObserver.observe(section);
    section.classList.add("section--hidden");
});
const $1ee2b6306238ec66$var$imgTargets = document.querySelectorAll(".features__img");
const $1ee2b6306238ec66$var$loadImg = function(entries, observer) {
    const [entry] = entries;
    if (!entry.isIntersecting) return;
    // Get the value of data-my-variable attribute
    const imageName = entry.target.getAttribute("data-my-variable");
    // Determine the image source based on the value of data-my-variable
    let newSrc;
    switch(imageName){
        case "digital":
            newSrc = (0, (/*@__PURE__*/$parcel$interopDefault($f0600783150be9f9$exports)));
            break;
        case "grow":
            newSrc = (0, (/*@__PURE__*/$parcel$interopDefault($2a2d7f14d7828bc1$exports)));
            break;
        case "card":
            newSrc = (0, (/*@__PURE__*/$parcel$interopDefault($5e44f7f1cd015b56$exports)));
            break;
        default:
            newSrc = (0, (/*@__PURE__*/$parcel$interopDefault($f0600783150be9f9$exports))); // Default to digital image if no match found
    }
    // Replace src with the new image source
    entry.target.src = newSrc;
    // Remove lazy-img class after the new image is loaded
    entry.target.addEventListener("load", function() {
        entry.target.classList.remove("lazy-img");
    });
    // Stop observing the current target once the image is loaded
    observer.unobserve(entry.target);
};
const $1ee2b6306238ec66$var$imgObserver = new IntersectionObserver($1ee2b6306238ec66$var$loadImg, {
    root: null,
    threshold: 0,
    rootMargin: "200px"
});
$1ee2b6306238ec66$var$imgTargets.forEach((img)=>$1ee2b6306238ec66$var$imgObserver.observe(img));
// Slider
const $1ee2b6306238ec66$var$slider = function() {
    const slides = document.querySelectorAll(".slide");
    const btnLeft = document.querySelector(".slider__btn--left");
    const btnRight = document.querySelector(".slider__btn--right");
    let curSlide = 0;
    const maxSlide = slides.length;
    const dotContainer = document.querySelector(".dots");
    // Slider Functions:
    const createDots = function() {
        slides.forEach(function(_, i) {
            dotContainer.insertAdjacentHTML("beforeend", `<button class="dots__dot" data-slide="${i}"></button>`);
        });
    };
    // Style Dots
    const activateDot = function(slide) {
        document.querySelectorAll(".dots__dot").forEach((dot)=>dot.classList.remove("dots__dot--active"));
        document.querySelector(`.dots__dot[data-slide="${slide}"]`).classList.add("dots__dot--active");
    };
    // Slider Movement
    const goToSlide = function(slide) {
        slides.forEach((s, i)=>s.style.transform = `translateX(${100 * (i - slide)}%)`);
    };
    // Next Slide
    const nextSlide = function() {
        if (curSlide === maxSlide - 1) curSlide = 0;
        else curSlide++;
        goToSlide(curSlide);
        activateDot(curSlide);
    };
    // Prev Slide
    const prevSlide = function() {
        if (curSlide === 0) curSlide = maxSlide - 1;
        else curSlide--;
        goToSlide(curSlide);
        activateDot(curSlide);
    };
    const init = function() {
        goToSlide(0);
        createDots();
        activateDot(0);
    };
    init();
    // Event Handlers
    btnRight.addEventListener("click", nextSlide);
    btnLeft.addEventListener("click", prevSlide);
    // Keyboard functionality of slider
    document.addEventListener("keydown", function(e) {
        if (e.key === "ArrowLeft") prevSlide();
        if (e.key === "ArrowRight") nextSlide();
    });
    // Dot handler
    dotContainer.addEventListener("click", function(e) {
        if (e.target.classList.contains("dots__dot")) {
            const { slide: slide } = e.target.dataset;
            goToSlide(slide);
            activateDot(slide);
        }
    });
};
$1ee2b6306238ec66$var$slider();


//# sourceMappingURL=index.ff7952bd.js.map
